export const DAYS_RANGE = [
    {
        label: "7 Days",
        value : 7
    },
    {
        label: "14 Days",
        value : 14
    },
    {
        label: "30 Days",
        value : 30
    },
    {
        label: "All Time",
        value : null
    },
]

export const BID_STATUS = [
    {
        label: "All",
        value : 0
    },
    {
        label: "Ready to Review",
        value : 1
    },
    {
        label: "Finish and Paid",
        value : 2
    },
    {
        label: "Proceed to Deploy",
        value : 3
    },
]

export const OWNER = [
    {
        label: "Public Sector",
        value : 1
    },
    {
        label: "Private Sector",
        value : 2
    },
]

export const PAYMENT_STATUS = [
    {
        label: "All",
        value : 0
    },
    {
        label: "1 - Request Created",
        value : 1
    },
    {
        label: "2 - Bid Created",
        value : 2
    },
    {
        label: "3 - Bid Approved and Paid",
        value : 3
    },
    {
        label: "4 - Bid Declined",
        value : 4
    },
    {
        label: "5 - Order In Deployment",
        value : 5
    },
    {
        label: "6 - Order Checked In",
        value : 6 //
    },
    {
        label: "7 - Order Reviewed",
        value : 7
    },
    {
        label: "8 - Order Finished",
        value : 8 //
    },
    {
        label: "9 - Order Submitted for Payment",
        value : 9
    },
    {
        label: "10 - Order Cleared for Payment",
        value : 10
    },
    {
        label: "11 - Order Finished and Paid",
        value : 11 //
    },
    {
        label: "12 - Order Reviewed and Paid",
        value : 12
    },
    {
        label: "13 - Order Closed",
        value : 13
    },
]


export const detectEnv = () =>
  window.location.hostname === "masterkey.automa.id"
    ? "production"
    : "local";

const environment = {
    production: {
        REDUX_LOGGER: false
    },
    local: {
        REDUX_LOGGER: true
    }
}
    
export const activeFeature = environment[detectEnv()];